import AmdrFileImport from "./AmdrFileImport";

export default AmdrFileImport;
